module.exports = __webpack_public_path__ + "static/media/tristeza.e80eb5fd.jpg";